import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { FinResource, FinResourceType } from "@app/definitions/types"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import { viewItemUrl } from "@app/helpers"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { ApiService } from "@app/services/api.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { CancelBtnComponent } from "@app/utils/utils.component"
import { environment } from "@env/environment"

@Component({
	selector: "app-print-email-prompt",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		CancelBtnComponent,
		ModalWrapComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<button
				class="btn btn-primary"
				(click)="view()"
			>
				{{ "see_document" | langVal }}
			</button>
		</div>
		<div>
			<button
				class="btn btn-primary"
				(click)="download()"
			>
				{{ "to_download_document" | langVal }}
			</button>
		</div>
		<div>
			<button
				class="btn btn-primary"
				(click)="openContactwaysModal()"
			>
				{{ "send_by_email" | langVal }}
			</button>
		</div>
		<div class="modal-btns">
			<div>
				<app-cancel-btn (click)="onClose.emit()" />
			</div>
		</div>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				title="contactways"
				modalWrapperClass="modal-wide"
			>
				<app-gen-table-display
					(onClose)="modalProps = null; $event?.length && download($event)"
					tableName="contactways"
					[filterField]="modalProps.fieldName"
					[filterFieldValue]="finresourceObj[modalProps.fieldName]"
					fieldNameInItemToDisplay="contactway"
					isCheckItems
					[filterFieldApiObject]="modalProps.filterFieldApiObject"
					[emailsAndPhoneValidation]="modalProps.emailsAndPhoneValidation"
				/>
			</app-modal-wrap>
		}
	`,
})
export class PrintEmailPromptComponent {
	modalProps: any = null
	@Output() onClose = new EventEmitter()
	@Input() finresourceObj: any = null

	constructor(
		public apiService: ApiService,
		public store: StoreService,
		public modalService: ModalService
	) {}

	async openContactwaysModal() {
		const fieldName = this.store.getPersonFieldName(this.finresourceObj)
		this.modalProps = { fieldName, ...this.store.phoneEmailValidationAttrs() }
	}
	async download(arrRows: any[] | null = null) {
		//  on English copy - isEn = true
		let sendObj: any = { ...this.finresourceObj, by_email: "no" }

		if (arrRows) {
			sendObj.emails_list = JSON.stringify(
				arrRows.map((row) => ({
					email: row.contactway,
					description: row.description,
				}))
			)
			sendObj.by_email = "yes"
		}
		if (sendObj.by_email == "yes") {
			this.modalService.openToast("sent_to")
		} else {
			this.modalService.openToast("download_process")
		}
		this.onClose.emit(true)

		this.store.downloadToastFunc(async () => {
			const res = await this.apiService.download("print_make_finresource", {
				...sendObj,
				id: this.finresourceObj.id,
				doctype: this.finresourceObj.doctype,
				isEn: true,
			})
			if (!res?.size) {
				return this.store.downloadFailedModal()
			}
			this.apiService.downloadFile(
				res,
				`${this.finresourceObj.doctype}_${this.finresourceObj.id}_copy_en.pdf`
			)
			this.modalService.openToast("download_success")
		})
	}
	view() {
		window.open(
			viewItemUrl(this.finresourceObj.id, this.finresourceObj.doctype, true),
			"_blank"
		)
	}
}
